export default {
	// 1) Declare a prop com type/default
	props: {
		atendimento: {
			type: Object,
			default: null,
		},
	},

	emits: ['clickEditarAtendimento'],

	methods: {
		formatIsoToBrDate(isoDateStr) {
			const date = new Date(isoDateStr)
			const day = String(date.getDate()).padStart(2, '0')
			const month = String(date.getMonth() + 1).padStart(2, '0')
			const year = date.getFullYear()
			return `${day}/${month}/${year}`
		},

		onClickEditarAtendimento() {
			if (this.atendimento && this.atendimento.id != null) {
				this.$emit('clickEditarAtendimento', this.atendimento.id)
			}
		},
	},

	template: html`
		<div class="info-atendimento">
			<q-expansion-item expand-separator group="info_atendimento_group">
				<template v-slot:header>
					<div class="row items-center gap-18 w-full h-full">
						<svg class="w-28 h-28">
							<use xlink:href="#icon_atendimento_menssagem"></use>
						</svg>
						<span>
							{{ atendimento?.data_atendimento ?
							formatIsoToBrDate(atendimento.data_atendimento) : '' }}
						</span>
						<div
							class="inline-block font-bold truncate max-w-[14rem] text-text-title-1">
							<span> {{ atendimento?.titulo_atendimento }} </span>

							<q-tooltip :delay="500"> {{ atendimento?.titulo_atendimento }} </q-tooltip>
						</div>

						<div class="inline-flex justify-end flex-1">
							<span
								class="mr-10 text-blue-10 cursor-pointer"
								@click="onClickEditarAtendimento">
								Editar
							</span>
						</div>
					</div>
				</template>

				<q-card>
					<q-card-section>
						<div v-html="atendimento?.descricao_atendimento" class="pl-1"></div>
					</q-card-section>
				</q-card>
			</q-expansion-item>
		</div>
	`,
}
